<template>
  <div class="-mt-6 mb-8 px-8 -mx-8">
    <div class="releases">
      <template v-for="(release, key) in pluginChangelog" :key="key">
        <changelog-release
          :release="release"
          :class="[
            {
              'border-b border-separator border-gray-200 dark:border-gray-700 border-solid':
                key < pluginChangelog.length,
            },
          ]"
        />
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
  import ChangelogRelease from './ChangelogRelease.vue';
  import {toRefs} from '#imports';

  const props = defineProps<{
    pluginChangelog: any[];
  }>();

  const {pluginChangelog} = toRefs(props);
</script>
